import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDaysInMonth } from "date-fns";
import "../../styles/payrole-system/payrole-processor.css";
import {
  AttendanceCalendarIcon,
  PersonIcon,
  XIcon,
} from "../../images/icons/icons";
import { fetchPayrollDetailData } from "../../redux/payrole-reducers/payroleSlice";
import { convertStraight, getMonthYear } from "../common-data/Converts";
import {
  getAttendanceStatus,
  getFirstDayOfMonth,
  getFormattedDate,
  getMonthName,
} from "./PayroleMocks";

const PayrollDetailsModal = ({ userInfoData, onClose, rowData }) => {
  const dispatch = useDispatch();
  const { payrollDetailData, payrollDetailLoading, payrollDetailError } =
    useSelector((state) => state.payrole);

  // const getFormattedDate = () => {
  //   if (rowData?.date) {
  //     return rowData.date;
  //   } else if (rowData?.month_year) {
  //     return `${rowData.month_year}-01`;
  //   }
  //   return "";
  // };

  const iniFilters = {
    user_id: rowData?.user_id || "",
    // user_id: "s1TY6WLhSV1q2",
    month: getFormattedDate(rowData),
  };
  const [filters, setFilters] = useState(iniFilters);

  const [allData, setAllData] = useState({});

  const employee = {
    name: allData?.salary_summary?.name || "Employee",
    month: allData?.salary_summary?.month || "-",
    joiningDate: convertStraight(allData?.salary_summary?.joining_date) || "-",
    salary: {
      base: parseFloat(allData?.salary_summary?.base_salary || 0),
      totalDays: allData?.salary_summary?.total_days || 0,
      workingDays: allData?.salary_summary?.working_days || 0,
      fullDays: allData?.salary_summary?.full_days || 0,
      halfDays: allData?.salary_summary?.half_days || 0,
      absentDays: allData?.salary_summary?.absent_days || 0,
      holidays: allData?.salary_summary?.holidays || 0,
      gross: parseFloat(allData?.salary_summary?.gross_salary_sum || 0),
      deductions: parseFloat(allData?.salary_summary?.deduction || 0),
      net: parseFloat(allData?.salary_summary?.net_salary || 0),
      incentive: parseFloat(allData?.salary_summary?.incentive || 0),
    },
    leave: {
      sick: {
        used: parseInt(
          allData?.leave?.find((l) => l.name === "Sick Leave")?.leave_taken || 0
        ),
        total:
          allData?.leave?.find((l) => l.name === "Sick Leave")?.total_leave ||
          0,
        pending: 0,
      },
      casual: {
        used: parseInt(
          allData?.leave?.find((l) => l.name === "Casual Leave")?.leave_taken ||
            0
        ),
        total:
          allData?.leave?.find((l) => l.name === "Casual Leave")?.total_leave ||
          0,
        pending: 0,
      },
      annual: {
        used: parseInt(
          allData?.leave?.find((l) => l.name === "Unpaid leave")?.leave_taken ||
            0
        ),
        total:
          allData?.leave?.find((l) => l.name === "Unpaid leave")?.total_leave ||
          0,
        pending: 0,
      },
      totalUsed:
        allData?.leave?.reduce(
          (sum, l) => sum + parseInt(l.leave_taken || 0),
          0
        ) || 0,
      pendingRequests: 0,
    },
    attendance: allData?.calander || [],
  };

  const getPayrollDetail = (filters) => {
    dispatch(
      fetchPayrollDetailData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getPayrollDetail(filters);
  }, [filters]);

  useEffect(() => {
    if (
      !payrollDetailLoading &&
      !payrollDetailError &&
      payrollDetailData?.status &&
      payrollDetailData?.data
    ) {
      setAllData(payrollDetailData.data);
    } else {
      setAllData({});
    }
  }, [payrollDetailLoading, payrollDetailError, payrollDetailData]);

  console.log("allData=> ", allData);

  return (
    <div className="pp-payroll-details-modal-overlay">
      <div className="pp-payroll-details-modal-container">
        <div className="pp-payroll-details-modal-header">
          <div className="pp-payroll-details-modal-header-left">
            <span className="pp-payroll-details-modal-header-left-icon">
              <PersonIcon />
            </span>

            <div className="pp-payroll-emp-detail">
              <span className="pp-payroll-details-modal-title">
                Payroll Details – {employee.name}
              </span>

              <span className="pp-payroll-joining-date">
                Joining Date: {employee.joiningDate}
              </span>
            </div>

            <span
              className="pp-payroll-details-modal-badge"
              style={{ marginLeft: 0 }}
            >
              {getMonthYear(employee.month)}
            </span>
          </div>

          <button
            className="pp-payroll-details-modal-close-btn"
            aria-label="Close"
            onClick={onClose}
          >
            <XIcon />
          </button>
        </div>

        <div className="pp-payroll-details-modal-grid">
          <div className="pp-payroll-details-card">
            <h3 className="pp-payroll-details-card-title">Salary Summary</h3>

            <div className="pp-payroll-details-summary-grid">
              <div className="span2">
                <div className="pp-payroll-details-summary-label">
                  Base Salary
                </div>
                <div className="pp-payroll-details-summary-value">
                  ₹{employee.salary.base.toLocaleString()}
                </div>
              </div>
            </div>

            <div className="pp-payroll-details-summary-grid">
              <div>
                <div className="pp-payroll-details-summary-label">
                  Total Days
                </div>
                <div className="pp-payroll-details-summary-value">
                  {employee.salary.totalDays}
                </div>
              </div>
              <div>
                <div className="pp-payroll-details-summary-label">
                  Working Days
                </div>
                <div className="pp-payroll-details-summary-value">
                  {employee.salary.workingDays}
                </div>
              </div>
            </div>

            <div className="pp-payroll-details-summary-grid">
              <div>
                <div className="pp-payroll-details-summary-label">
                  Full Days
                </div>
                <div className="pp-payroll-details-summary-value green">
                  {employee.salary.fullDays}
                </div>
              </div>
              <div>
                <div className="pp-payroll-details-summary-label">
                  Half Days
                </div>
                <div className="pp-payroll-details-summary-value yellow">
                  {employee.salary.halfDays}
                </div>
              </div>
              <div>
                <div className="pp-payroll-details-summary-label">
                  Absent Days
                </div>
                <div className="pp-payroll-details-summary-value red">
                  {employee.salary.absentDays}
                </div>
              </div>
              <div>
                <div className="pp-payroll-details-summary-label">Week off</div>
                <div className="pp-payroll-details-summary-value blue">
                  {employee.salary.holidays}
                </div>
              </div>
            </div>

            <div className="pp-payroll-details-summary-row">
              <span>Gross Salary</span>
              <span>₹{employee.salary.gross.toLocaleString()}</span>
            </div>

            <div className="pp-payroll-details-summary-row">
              <span className="green">Incentives</span>
              <span className="green">
                +₹{employee.salary.incentive.toLocaleString()}
              </span>
            </div>

            <div className="pp-payroll-details-summary-row">
              <span className="red">Deductions</span>
              <span className="red">
                -₹{employee.salary.deductions.toLocaleString()}
              </span>
            </div>

            <div className="pp-payroll-details-summary-row net">
              <span>Net Salary</span>
              <span>₹{employee.salary.net.toLocaleString()}</span>
            </div>
          </div>

          <div className="pp-payroll-details-card">
            <h3 className="pp-payroll-details-card-title">Leave Balance</h3>
            <div className="pp-payroll-details-leave-row">
              <span>Sick Leave</span>
              <span>
                {employee.leave.sick.used}/{employee.leave.sick.total}
              </span>
            </div>
            <div className="pp-payroll-details-leave-bar sick">
              <div
                style={{
                  width: `${
                    (employee.leave.sick.used / employee.leave.sick.total) * 100
                  }%`,
                }}
              />
            </div>

            <div className="pp-payroll-details-leave-row">
              <span>Casual Leave</span>
              <span>
                {employee.leave.casual.used}/{employee.leave.casual.total}
              </span>
            </div>
            <div className="pp-payroll-details-leave-bar casual">
              <div
                style={{
                  width: `${
                    (employee.leave.casual.used / employee.leave.casual.total) *
                    100
                  }%`,
                }}
              />
            </div>

            <div className="pp-payroll-details-leave-row">
              <span>Annual Leave</span>
              <span>
                {employee.leave.annual.used}/{employee.leave.annual.total}
              </span>
            </div>
            <div className="pp-payroll-details-leave-bar annual">
              <div
                style={{
                  width: `${
                    (employee.leave.annual.used / employee.leave.annual.total) *
                    100
                  }%`,
                }}
              />
            </div>

            <div className="pp-payroll-details-leave-summary">
              <div>
                Total Leaves Used <span>{employee.leave.totalUsed}</span>
              </div>
              <div className="pp-payroll-details-leave-pending orange">
                Pending Requests <span>{employee.leave.pendingRequests}</span>
              </div>
            </div>
          </div>

          <div className="attendance-calendar-card">
            <div className="calendar-header">
              <span className="calendar-icon">
                <AttendanceCalendarIcon />
              </span>
              Attendance Calendar
            </div>
            <div className="calendar-navigation">
              <button className="nav-button nav-button-previous">&#60;</button>
              <span className="month-year-label">
                {getMonthName(employee.month)}
              </span>
              <button className="nav-button nav-button-next">&#62;</button>
            </div>
            <div className="calendar-table">
              <div className="calendar-header-row">
                {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                  <div className="calendar-header-cell" key={d}>
                    {d}
                  </div>
                ))}
              </div>
              {(() => {
                const attendanceMap = {};
                employee.attendance.forEach((day) => {
                  const date = new Date(day.date);
                  const dayNum = date.getDate();
                  attendanceMap[dayNum] = day;
                });

                const date = new Date(employee.month);
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const daysInMonth = getDaysInMonth(year, month);
                const firstDay = getFirstDayOfMonth(year, month);

                const weeks = [];
                let currentWeek = [];

                for (let i = 0; i < firstDay; i++) {
                  currentWeek.push(
                    <div className="calendar-cell" key={`empty-${i}`}>
                      <span className="calendar-day day-outside"></span>
                    </div>
                  );
                }

                for (let day = 1; day <= daysInMonth; day++) {
                  const dayData = attendanceMap[day];
                  const statusClass = getAttendanceStatus(dayData);

                  currentWeek.push(
                    <div className="calendar-cell" key={day}>
                      <span className={`calendar-day ${statusClass}`}>
                        {day}
                      </span>
                    </div>
                  );

                  if (currentWeek.length === 7) {
                    weeks.push(
                      <div className="calendar-row" key={weeks.length}>
                        {currentWeek}
                      </div>
                    );
                    currentWeek = [];
                  }
                }

                while (currentWeek.length < 7 && currentWeek.length > 0) {
                  currentWeek.push(
                    <div
                      className="calendar-cell"
                      key={`empty-end-${currentWeek.length}`}
                    >
                      <span className="calendar-day day-outside"></span>
                    </div>
                  );
                }

                if (currentWeek.length > 0) {
                  weeks.push(
                    <div className="calendar-row" key={weeks.length}>
                      {currentWeek}
                    </div>
                  );
                }

                return weeks;
              })()}
            </div>

            <div className="calendar-legend">
              <div className="legend-title">Legend:</div>
              <div className="legend-grid">
                <div className="legend-item">
                  <span className="legend-color legend-present"></span> Present
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-absent"></span> Absent
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-half"></span> Half Day
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-late"></span> Late
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-leave"></span> Leave
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-weekoff"></span> Week Off
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-saturday"></span>{" "}
                  Saturday
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-sunday"></span> Sunday
                </div>
                <div className="legend-item">
                  <span className="legend-color legend-rostered"></span>{" "}
                  Rostered
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollDetailsModal;
